import { CSSObject } from '@chakra-ui/react';

export const MatchesContainer: CSSObject = {
  px: '0',
  pt: '2',
};
